/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

export default class Salesforce {
    /**
     * reexport a customer from celeraone to salesforce
     * @param ssoId
     * @returns Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static reexport(ssoId) {
        return Http.post(`/salesforce/reexport/${ssoId}`);
    }
}
